const TAG_ID = 'styleInjection';

const ONBOARDING_CLASS = 'cdo';

const ONBOARDING_TYPE = 'onboarding';

const DASHBOARD_TYPE = 'dashboard';

export const FONT_PROPERTY = {
  font_family: 'Open Sans',
  font_size_h1: '32px',
  font_size_h2: '24px',
  font_size_h3: '18px',
  font_size_h4: '16px',
  font_size_h5: '14px',
  font_size_h6: '14px',
};

// eslint-disable-next-line func-style
function setFontFamily(property) {
  return `.application, body, body a{
        font-family: ${property} !important;
    }
    .v-application, .v-application .text-body-1, .v-application .text-caption {
      font-family:${property} !important;
    }`;
}

// eslint-disable-next-line unicorn/no-static-only-class
export default class StyleInjector {
  static inject(dashboardType, styleObj) {
    let propertyMapping = {};

    // this object contains all of the styles we need to apply
    let styleContent = `<style id=${TAG_ID}>`;

    // eslint-disable-next-line default-case
    switch (dashboardType) {
      case ONBOARDING_TYPE: {
        propertyMapping = StyleInjector.onboardingProperties(styleObj);
        break;
      }
      case DASHBOARD_TYPE: {
        propertyMapping = StyleInjector.dashboardProperties(styleObj);
        break;
      }
    }

    // eslint-disable-next-line no-restricted-syntax
    for (const propertyName in propertyMapping) {
      // if a property exists, execute its function
      if (styleObj[propertyName]) {
        styleContent += propertyMapping[propertyName](styleObj[propertyName]);
      }
    }

    styleContent += `</style>`;

    const div = document.createElement('div');

    div.innerHTML = styleContent.trim();

    document.head.append(div.firstChild);

    if (dashboardType === ONBOARDING_TYPE) {
      document.body.classList.add(ONBOARDING_CLASS);
    }
  }

  // eslint-disable-next-line max-lines-per-function
  static onboardingProperties() {
    // this object maps property names with what they should do
    return {
      font_family: setFontFamily,
      font_size_h1: (property) => `.${ONBOARDING_CLASS} h1{
            font-size: ${property} !important;
        } `,
      font_size_h2: (property) => `.${ONBOARDING_CLASS} h2{
            font-size: ${property} !important;
        } `,
      font_size_h3: (property) => `.${ONBOARDING_CLASS} h3{
            font-size: ${property} !important;
        } `,
      font_size_h4: (property) => `.${ONBOARDING_CLASS} h4{
            font-size: ${property} !important;
        } `,
      font_size_h5: (property) => `.${ONBOARDING_CLASS} h5{
            font-size: ${property} !important;
        } `,
      font_size_h6: (property) => `.${ONBOARDING_CLASS} h6{
            font-size: ${property} !important;
        } `,
    };
  }

  static dashboardProperties() {
    // this object maps property names with what they should do
    return {
      fontSize: (property) =>
        // this is where we need to apply font styles
        // "property" will be 14, 15, or 16
        `body{
          font-size: ${property}px !important;
        }`,
      fontFamily: setFontFamily,
    };
  }

  static clear() {
    document.querySelector(`#${TAG_ID}`).remove();
    document.body.classList.remove(ONBOARDING_CLASS);
  }

  static get DASHBOARD_TYPE() {
    return DASHBOARD_TYPE;
  }

  static get ONBOARDING_TYPE() {
    return ONBOARDING_TYPE;
  }
}
